import { Component, OnInit, TemplateRef, ViewChild, inject, output, input } from '@angular/core';

import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { TextEngines, TextEngineOptions, VoiceTTSOptions, AudioSpeed } from '../../../models/conversation-enums';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

import { CONVERSATION_AI_TOKEN, AgentCardsAbstractService } from '../../../models/conversation-ai.class';
import { CheckboxModule } from 'primeng/checkbox';
import { SliderModule } from 'primeng/slider';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ButtonModule } from 'primeng/button';
import { SpeedDescPipe } from '../../../pipes/speed.pipe';
import { RatingModule } from 'primeng/rating';
import { TableModule } from 'primeng/table';
import { BadgeModule } from 'primeng/badge';
import { SkeletonModule } from 'primeng/skeleton';
import { TooltipModule } from 'primeng/tooltip';
import { ProviderSelectorComponent } from '../../provider-selector/provider-selector.component';
import { SelectModule } from 'primeng/select';

@Component({
  selector: 'dc-chat-settings-dialog',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CheckboxModule,
    SliderModule,
    RadioButtonModule,
    ButtonModule,
    SpeedDescPipe,
    RatingModule,
    TableModule,
    BadgeModule,
    SkeletonModule,
    TooltipModule,
    ProviderSelectorComponent,
    SelectModule,
  ],
  templateUrl: './dc-conversation-userchat-settings.component.html',
  styleUrls: ['./dc-conversation-userchat-settings.component.css'],
})
export class DCConversationUserChatSettingsComponent implements OnInit {
  private dialogRef = inject(DynamicDialogRef);
  private fb = inject(FormBuilder);
  private conversationCardAIService = inject<AgentCardsAbstractService>(CONVERSATION_AI_TOKEN);

  public isLoadingModels = true;

  readonly showFeature = input<any>({
    synthVoice: true,
    highlightWords: true,
    speed: true,
    realTime: true,
    superHearing: true,
    fixGrammar: true,
    autoTranslate: true,
  });

  readonly onSettingsChange = output<any>();

  textEngines = Object.values(TextEngines);
  voiceTTSOptions = Object.values(VoiceTTSOptions);
  textEngineOptions = TextEngineOptions;

  public speedOptions = Object.values(AudioSpeed).map((speed) => ({ label: speed, value: speed }));

  public modelnames = [];

  public form = this.fb.group({
    synthVoice: [false],
    highlightWords: [false],
    speed: [AudioSpeed.Regular],
    realTime: [false],
    repeatRecording: [false],
    superHearing: [false],
    fixGrammar: [false],
    autoTranslate: [false],
    userMessageTask: [false],
    assistantMessageTask: [false],
    voice: ['random'],
    model: this.fb.group({
      provider: ['google'],
      modelName: [''],
      id: [''],
    }),
  });

  @ViewChild('tooltipRef') tooltipRef!: TemplateRef<any>;

  public isAdmin: boolean = true;
  ngOnInit(): void {
    console.log('Settings form initialized', this.form.value, this.form.controls.highlightWords);
    this.loadInitialSettings();

    this.form.valueChanges.subscribe((value) => {
      this.onSettingsChange.emit(value);
    });
  }

  private async loadInitialSettings() {
    const settings = await this.conversationCardAIService.getConversationUserChatSettings();
    if (settings) {
      this.form.patchValue(settings as any);
    }
  }

  close() {
    this.dialogRef.close();
  }

  async saveSettings() {
    if (this.form.valid) {
      await this.conversationCardAIService.saveConversationUserChatSettings(this.form.value as any);
      this.dialogRef.close(this.form.value);
    }
  }

  // modelTooltipTemplate(product: any) {
  //   return { template: this.tooltipRef, context: { model: product } };
  // }
}
